import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PROFILE_STYLES, PROFILE_TEXTS } from '../consts';
import Button from '../../../generic-components/Button';
import Icon from '../../../generic-components/Icon';
import { logoutIcon } from '../../../assets/svg';
import { useLogoutQuery } from '../../../hooks/query/useLogoutQuery';
import { VIEWS_MAP } from '../../../router/constants';
import { useStore } from '../../../store';
import { ISummaryData } from '../../../types';

export const LogoutBlock = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const summaryData: ISummaryData = useStore(state => state.summary);

  const { refetch: sendLogout } = useLogoutQuery({
    customerId: summaryData.customer.externalId,
    onSuccess: () => {
      localStorage.clear();
      navigate(`/${VIEWS_MAP.LOGIN}`);
    },
  });

  return (
    <div className={PROFILE_STYLES.LOGOUT_BTN_CONTAINER}>
      <Button
        id='logOut'
        title={t(PROFILE_TEXTS.LOGOUT_BTN_TEXT)}
        childElement={<Icon className='w-[20px] h-[20px] mr-[2px]' src={logoutIcon} />}
        className={PROFILE_STYLES.LOGOUT_BTN}
        onClick={sendLogout}
      />
    </div>
  );
};
